import React from 'react';
import {
  CustomDataTableConfig,
  HeadCell,
} from '../../../../../commons/components/custom-data-table/custom-data-table-config.model';
import CustomDataTableComponent from '../../../../../commons/components/custom-data-table/custom-data-table.component';
import { InvoiceDetail } from '../../../../../models/interfaces/InvoiceDetail.interface';

interface InvoiceTableComponentProps {
  invoices: InvoiceDetail[];
  onSelect?: Function;
}

export default function InvoiceTableComponent(props: InvoiceTableComponentProps) {
  const headCells: HeadCell[] = [
    { id: 'voucherNumber', field: 'voucherNumber', label: 'Invoice Nr' },
    {
      id: 'totalPriceNet',
      label: 'Total (net)',
      getFieldValueFunc: (invoice: InvoiceDetail) =>
        `${invoice?.totalPrice?.totalNetAmount} ${invoice?.totalPrice?.currency}`,
    },
    {
      id: 'totalPriceGross',
      label: 'Total',
      getFieldValueFunc: (invoice: InvoiceDetail) =>
        `${invoice?.totalPrice?.totalGrossAmount} ${invoice?.totalPrice?.currency}`,
    },
    { id: 'voucherStatus', field: 'voucherStatus', label: 'Status' },
    {
      id: 'item',
      label: 'Item',
      getFieldValueFunc: (invoice: InvoiceDetail) => invoice?.lineItems?.map(item => item.name),
    },
    { id: 'dueDate', field: 'dueDate', label: 'Due date' },
    { id: 'createdDate', field: 'createdDate', label: 'Created date' },
  ];

  const tableConfig: CustomDataTableConfig = {
    tableName: `Invoices`,
    rowsPerPage: 10,
    headCells,
  };

  return <CustomDataTableComponent tableConfig={tableConfig} data={props?.invoices} onSelect={props?.onSelect} />;
}
